import apiClient from '../middleware/apiClient';
import {
  COTTON_CSP_INTERNET_PLAN,
  CSP_INTERNET_PLAN,
} from '../helpers/apis';
import cottonFlagManager from '../helpers/featureFlags/cotton';
import { callApiWithFallback } from '../helpers/apiFallback';
import { kibanaLog } from '../helpers/logger';

export const GET_INTERNET_PLAN = 'GET_INTERNET_PLAN';
export const GET_INTERNET_PLAN_SUCCESS = 'GET_INTERNET_PLAN_SUCCESS';
export const GET_INTERNET_PLAN_FAILURE = 'GET_INTERNET_PLAN_FAILURE';

function dispatchGetInternetPlan(endpoint = CSP_INTERNET_PLAN) {
  return {
    type: GET_INTERNET_PLAN,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetInternetPlanSuccess(internetPlan) {
  return {
    type: GET_INTERNET_PLAN_SUCCESS,
    payload: internetPlan,
  };
}

function dispatchGetInternetPlanFailure(error) {
  return {
    type: GET_INTERNET_PLAN_FAILURE,
    payload: error,
  };
}

export const getInternetPlan = () => async (dispatch) => {
  try {
    let response;
    const { isAptV1Enabled, internetPlanEnabled } = cottonFlagManager;

    if (isAptV1Enabled) {
      kibanaLog('cotton_internet_plan_api_called');
      response = await dispatch(dispatchGetInternetPlan(COTTON_CSP_INTERNET_PLAN)).payload;
    } else if (internetPlanEnabled) {
      response = await callApiWithFallback(
        dispatch,
        () => dispatchGetInternetPlan(COTTON_CSP_INTERNET_PLAN),
        () => dispatchGetInternetPlan(CSP_INTERNET_PLAN),
        'internet_plan',
      );
    } else {
      response = await dispatch(dispatchGetInternetPlan(CSP_INTERNET_PLAN)).payload;
    }

    return dispatch(dispatchGetInternetPlanSuccess(response));
  } catch (error) {
    return dispatch(dispatchGetInternetPlanFailure(error));
  }
};
